import {useGet} from "@hooks/http.ts";
import {useCallback} from "react";
import {useOnce} from "@hooks/once.ts";

export type LeaderboardRow = {
    user: {
        id: string;
        wallet: string;
    }
    points: number;
    rank: number
};

export type LeaderboardResponse = {
    leaderboard: Array<LeaderboardRow>
}

type LeaderboardGetAction = (abortController?: AbortController) => void;

export const useLeaderboardGet = (): readonly [
        Array<LeaderboardRow> | undefined,
    boolean,
        Error | undefined,
    LeaderboardGetAction
] => {
    const [response, loading, error, get] = useGet<LeaderboardResponse>();
    const fetchLeaderboards = useCallback((abortController?: AbortController) => {
        console.trace("fetching Leaderboards");
        get(`/v1/leaderboard`, abortController);
    }, [get]);

    useOnce(() => {
        fetchLeaderboards()
    }, [fetchLeaderboards]);

    console.log(response)
    return [response?.leaderboard, loading, error, fetchLeaderboards] as const;
}

